/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_water_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add ~0.35 L for every 30 minutes of exercise.`)
};

const es_water_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añade ~0,35 L por cada 30 minutos de ejercicio.`)
};

const de_water_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Füge pro 30 Minuten Training rund 0,35 L hinzu.`)
};

const nl_water_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tel er ~0,35 L bij op voor elke 30 minuten sport.`)
};

const fr_water_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajoutez environ 0,35 L pour chaque tranche de 30 minutes d'exercice.`)
};

const it_water_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi circa 0,35 L ogni 30 minuti di esercizio.`)
};

const pt_br2_water_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicione ~0,35 L para cada 30 minutos de exercício.`)
};

const pt_water_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acrescente ~0,35 L por cada 30 minutos de exercício.`)
};

const ja_water_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`運動30分ごとに約0.35Lを追加してください。`)
};

const zh_water_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每运动 30 分钟，额外增加约 0.35 升。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const water_ex2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.water_ex2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("water_ex2", locale)
	if (locale === "en") return en_water_ex2(inputs)
	if (locale === "es") return es_water_ex2(inputs)
	if (locale === "de") return de_water_ex2(inputs)
	if (locale === "nl") return nl_water_ex2(inputs)
	if (locale === "fr") return fr_water_ex2(inputs)
	if (locale === "it") return it_water_ex2(inputs)
	if (locale === "pt-BR") return pt_br2_water_ex2(inputs)
	if (locale === "pt") return pt_water_ex2(inputs)
	if (locale === "ja") return ja_water_ex2(inputs)
	return zh_water_ex2(inputs)
};